type IsPlainObject<T> = T extends object
  ? // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
    T extends Function | any[]
    ? false
    : true
  : false;

type Prev = [never, 0, 1, 2, 3, 4, 5];

export type DotNotation<
  T,
  Prefix extends string = "",
  Depth extends number = 5,
> = [Depth] extends [never]
  ? never
  : {
      [K in keyof T & (string | number)]: IsPlainObject<
        NonNullable<T[K]>
      > extends true
        ?
            | `${Prefix}${K}`
            | DotNotation<NonNullable<T[K]>, `${Prefix}${K}.`, Prev[Depth]>
        : `${Prefix}${K}`;
    }[keyof T & (string | number)];

type DotValue<T, Path extends string, Depth extends number = 5> = [
  Depth,
] extends [never]
  ? never
  : Path extends `${infer Key}.${infer Rest}`
    ? Key extends keyof T
      ? DotValue<T[Key], Rest, Prev[Depth]>
      : never
    : Path extends keyof T
      ? T[Path]
      : never;

export function getByDotPath<T>(
  obj: T,
  path: DotNotation<T>
): DotValue<T, DotNotation<T>> {
  const parts = (path as string).split(".");
  let result: unknown = obj;
  for (const part of parts) {
    if (result == null || typeof result !== "object") {
      return undefined as DotValue<T, DotNotation<T>>;
    }
    result = (result as Record<string, unknown>)[part];
  }
  return result as DotValue<T, DotNotation<T>>;
}
